// 这里只能硬编码，用于跳转到账号页面，而页面地址应该是固定 wps.cn 的，@plus/env 的域名变量会随着域名变化而改变
var ACCOUNT = "https://account.wps.cn";
var KDOCS = "https://www.kdocs.cn";
var WPSPLUS = "https://wpsplus.com";
var wpsplusAppid = {
    dev: 'AK20200311SMDNJR',
    prod: 'AK20200317NIXICH'
};

var getWpsplusAppid = function () {
    var accessID = wpsplusAppid.prod; // 生产环境 appid
    try {
        // @ts-ignore
        if (process.env.NODE_ENV === 'development' || process.env.KAE_ENVIRONMENT === 'beta' || process.env.VUE_APP_KAE_ENVIRONMENT === 'beta' || process.env.VITE_APP_KAE_ENVIRONMENT === 'beta') {
            accessID = wpsplusAppid.dev; // beta 环境 appid
        }
    }
    catch (e) { }
    return accessID;
};
var getRedirectSSO = function (cbUrl) {
    var appid = getWpsplusAppid();
    var pageUrl = "".concat(ACCOUNT, "/api/v3/session/correlate/redirect?appid=").concat(appid, "&cb=").concat(encodeURIComponent(cbUrl));
    return pageUrl;
};

var errorText = '@single-sign异常: Cannot read properties of undefined (reading cbUrl)';
var SingleSign = /** @class */ (function () {
    function SingleSign() {
    }
    // kdocs单点登录
    SingleSign.prototype.kdocsSingleSign = function (params) {
        var cbUrl = (params || {}).cbUrl;
        if (!cbUrl)
            throw new Error(errorText);
        return "".concat(KDOCS, "/login?cb=").concat(encodeURIComponent(cbUrl));
    };
    // wpsplus单点登录
    SingleSign.prototype.wpsplusSingleSign = function (params) {
        var cbUrl = (params || {}).cbUrl;
        if (!cbUrl)
            throw new Error(errorText);
        var singleSignUrl = "".concat(WPSPLUS, "/singleSign4CST?cb=").concat(encodeURIComponent(cbUrl));
        return getRedirectSSO(singleSignUrl);
    };
    // 提供便捷式跳转，涵盖wps.cn单点登录kdocs.cn和wps.cn单点登录到wpsplus.com
    SingleSign.prototype.onSkipSingleSign = function (params) {
        var cbUrl = (params || {}).cbUrl;
        if (!cbUrl)
            throw new Error(errorText);
        var hostname = /(?:\w+\.)?wps\.cn/;
        if (!hostname.test(location.host)) {
            location.href = cbUrl;
            return true;
        }
        var match = cbUrl.match(/\/\/([^/]+)/);
        var host = match ? match[1] : '';
        console.log(match); // plus.kdocs.cn
        if ((/(?:\w+\.)?kdocs\.cn/).test(host)) {
            location.href = this.kdocsSingleSign(params);
            return true;
        }
        if ((/(?:\w+\.)?wpsplus\.com/).test(host)) {
            location.href = this.wpsplusSingleSign(params);
            return true;
        }
        location.href = cbUrl;
    };
    return SingleSign;
}());
var index = new SingleSign();

export { index as default };
